import { NotificationI, getNotificationTypes, notificationTypes } from "./notificationTypes";

export const notify = (payload: NotificationI): getNotificationTypes => ({
  type: notificationTypes.NOTIFY,
  payload,
});

export const clearNotificationData = (): getNotificationTypes => ({
  type    : notificationTypes.CLEAR_NOTIFICATION_DATA,
  payload : { type: "info", message: "" },
});
